module.exports = __webpack_public_path__ + "static/media/processor.e51edd63.png";